/* eslint-disable react/no-array-index-key */
import React from 'react';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';

interface BoxTableShimmerProps {
  shimmerDimensions?: Array<Array<string>>;
  columnDimensions?: Array<string>;
  headerHeightDimension?: string;
  bodyHeightDimension?: string;
  type?: string;
  dataId?: string;
}

function BoxTableShimmer({
  shimmerDimensions,
  columnDimensions,
  headerHeightDimension = '40px',
  bodyHeightDimension = '56px',
  type,
  dataId = ''
}: BoxTableShimmerProps) {
  const dataIdGenerator = getDataIdGenerator('box-table-shimmer', dataId);

  const columnDimensionsAvailable = columnDimensions?.length > 0;
  const shimmerDimensionsAvailable = shimmerDimensions?.length > 0;
  return (
    <table className={`box-table ${type}`} data-id={dataIdGenerator('')}>
      <thead>
        {columnDimensionsAvailable ? (
          <tr>
            {columnDimensions.map((dimension, index) => (
              <th
                key={index}
                className='table-shimmer-header'
                style={{ width: dimension, height: headerHeightDimension }}
              >
                <div className='shimmer shimmer-line' style={{ width: dimension }} />
              </th>
            ))}
          </tr>
        ) : null}

        {shimmerDimensionsAvailable ? (
          <tr>
            {shimmerDimensions[0].map((dimension, index) => (
              <th
                key={index}
                className='table-shimmer-header'
                style={{ height: headerHeightDimension }}
              >
                <div className='shimmer shimmer-line' style={{ width: dimension }} />
              </th>
            ))}
          </tr>
        ) : null}
      </thead>

      <tbody>
        {shimmerDimensionsAvailable
          ? shimmerDimensions.map((dimension, index) => (
              <tr key={index}>
                {dimension.map((size, i) => (
                  <td key={i} style={{ height: bodyHeightDimension }}>
                    <div className='shimmer shimmer-line mt-5' style={{ width: size }} />
                  </td>
                ))}
              </tr>
            ))
          : null}
      </tbody>
    </table>
  );
}

export default BoxTableShimmer;
